const state = {
    term: null,
    currentPage : 1,
    category : "",
    scroll: 0
}
const actions = {

}
const mutations = {
    setCurrentPage (state, val) {
        state.currentPage = val
    },
    setTerm (state, val) {
        state.term = val
    },
    setCategory (state, val) {
        state.category = val
    },
    setScroll(state,val){
        state.scroll = val;
    }
}
export default {
    state,
    mutations,
    actions,
}